import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { getError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2, Loader2 } from "lucide-react";

export default function Entity() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/entity");
        setName(data.name || "");
      } catch {} finally {
        setLoading(false);
      }
    })();
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/entity", { name });
      toast.success("تم حفظ بيانات الجهة");
    } catch (err) {
      toast.error(getError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="entity-page">
      <h1 className="text-2xl md:text-3xl font-extrabold text-primary">بيانات الجهة</h1>
      <div className="bg-white rounded-lg border border-border shadow-[0_4px_20px_-4px_rgba(15,61,62,0.08)] max-w-xl">
        <div className="flex items-center gap-2 bg-primary text-white rounded-t-lg px-5 py-3 font-bold">
          <Building2 className="h-5 w-5" />
          اسم الجهة
        </div>
        <form onSubmit={save} className="p-6 space-y-4">
          {loading ? (
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
          ) : (
            <>
              <div className="space-y-2">
                <Label>اسم الجهة</Label>
                <Input value={name} onChange={(e) => setName(e.target.value)} disabled={!isAdmin} placeholder="أدخل اسم الجهة" data-testid="entity-name-input" />
              </div>
              {isAdmin ? (
                <Button type="submit" disabled={saving} className="bg-primary hover:bg-secondary transition-colors" data-testid="entity-save-btn">
                  {saving && <Loader2 className="h-4 w-4 animate-spin ms-2" />}
                  حفظ
                </Button>
              ) : (
                <p className="text-xs text-muted-foreground">يمكن تعديل اسم الجهة من قبل المسؤول فقط</p>
              )}
            </>
          )}
        </form>
      </div>
    </div>
  );
}
